import { render } from "./XcxShow.vue?vue&type=template&id=223114d1&scoped=true"
import script from "./XcxShow.vue?vue&type=script&lang=js"
export * from "./XcxShow.vue?vue&type=script&lang=js"

import "./XcxShow.vue?vue&type=style&index=0&id=223114d1&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-223114d1"]])

export default __exports__